module.exports = __webpack_public_path__ + "site/img/225.70c37804.jpg";